export default function insertStyle(css) {
  const style = document.createElement('style');
  style.type = 'text/css';
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);
  return function() {
    document.head.removeChild(style);
  };
}
